import { TextField, Typography } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T } from '../../../../../Translations';

interface Props {
  internalNameValue: string;
  onFieldHide: () => void;
  addInternalName: (value: string) => void;
}

function InternalTextField({ internalNameValue, onFieldHide, addInternalName }: Props) {
  return (
    <>
      <TextField
        onChange={(e) => addInternalName(e.target.value)}
        className="h-full rounded-6 pl-3 pr-4 !shadow-none !outline-0 h-[25px]"
        inputClassName="pl-0 border-none !ring-0"
        autoFocus
        fullWidth
        onBlur={onFieldHide}
        maxLength={150}
        value={internalNameValue}
      />
      <Typography
        color="teal"
        variant="caption"
        fontWeight="semibold"
        className="ml-2 cursor-pointer text-nowrap"
        onClick={onFieldHide}
      >
        <T kind="Save" />
      </Typography>
    </>
  );
}

export default observer(InternalTextField);
